import { Component, EventEmitter, Output } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { LimitedUnassignExpiredUnexecutedSubProjectsControllerRequestService } from './service/limited-unassign-expired-unexecuted-subprojects-controller-request.service';

@Component({
  selector: 'test-unassign-expired-subprojects-modal',
  templateUrl: './test-unassign-expired-subprojects-modal.component.html',
  styleUrls: ['./test-unassign-expired-subprojects-modal.component.scss'],
})
export class TestUnassignedExpiredSubProjectsModalComponent {
  @Output()
  success = new EventEmitter<never>();

  submitting: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<TestUnassignedExpiredSubProjectsModalComponent>,
    private limitedUnassignExpiredUnexecutedSubProjectsControllerRequestService: LimitedUnassignExpiredUnexecutedSubProjectsControllerRequestService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  doUnassignExpiredSubProjects(): void {
    this.submitting = true;
    this.limitedUnassignExpiredUnexecutedSubProjectsControllerRequestService
      .limitedUnassignExpiredUnexecutedSubProjects()
      .then(() => this.success.emit())
      .finally(() => (this.submitting = false));
  }
}
